import React from "react";
import moment from 'moment';
import {component_tool, utils_tool} from "@/tool";
import { WizTableForm } from '@/containers/common';
const organizationConfig = WizTableForm.Config.organization(this, { apiParams: { state: 1, isNotAuth: false } })
const positionConfig = WizTableForm.Config.position(this, { apiParams: { state: 1, isNotAuth: false } })
let {WizModal} = component_tool;
let {$$, checkStrLength} = utils_tool;
//配置项
let componentName = 'classStudentManagement';
import ClassStudentAdd from './classStudentAdd';
import ClassStudentFileImport from './classStudentFileImport';

let ref_;
const formatterDate = (val) => {
  return val ? moment(val).format('YYYY-MM-DD HH:mm:ss') : '';
}
const columns = (data) => {
  const {classInfoId,className} = data;
  return [
    {
      name: "id",
      formItem: {
        type: "hidden"
      }
    },

    {
      title: "姓名",
      name: "fullName",
      tableItem: {
        width: 100,
      },
      searchItem: {}
    },
    {
      title: "账号",
      name: "userName",
      tableItem: {
        width: 100,
      },
      searchItem: {}
    },
    {
      title: "手机号",
      name: "mobile",
      tableItem: {
        width: 150,
      },
    },
    // {
    //   title: "身份证号",
    //   name: "idCard",
    //   tableItem: {
    //     width: 200,
    //   },
    // },
    // {
    //   title: "用户属性",
    //   name: "userType",
    //   dict: [
    //     { code: 0, codeName: "学员" },
    //     { code: 1, codeName: "总部" },
    //     { code: 2, codeName: "区域" },
    //     { code: 3, codeName: "供应商" }
    //   ],
    //   tableItem: {
    //     width: 100,
    //   },
    // },

    {
      title: "组织名称",
      name: "orgIds",
      searchItem: {
        diy: WizTableForm,
        ...organizationConfig,
      }
    },
    {
      title: "岗位",
      name: "positionIds",
      searchItem: {
        diy: WizTableForm,
        ...positionConfig,
      }
    },

    {
      title: "组织名称",
      name: "orgName",
      tableItem: {
        width: 150,
      }
    },
    {
      title: "组织编码",
      name: "orgCode",
      tableItem: {
        width: 120,
      },
    },
    {
      title: "岗位",
      name: "positionName",
      tableItem: {
        width: 100,
      }
    },
    {
      title: "任职状态",
      name: "jobState",
      dict: [
        { code: 0, codeName: '离职' },
        { code: 1, codeName: '在职' },
      ],
      tableItem: {
        width: 100,
      },
    },
    {
      title: "是否请假",
      name: "leaveState",
      dict: [
        { code: 0, codeName: "否" },
        { code: 1, codeName: "是" }
      ],
      tableItem: {
      },
      searchItem: {
        type: 'select'
      }
    },
    {
      title: "创建人",
      name: "creator",
      tableItem: {
        width: 100,
      }
    },
    {
      title: "创建时间",
      name: "createTime",
      tableItem: {
        width: 100,
      }
    },
    {
      title: "学员来源",
      name: "classStudentSource",
      dict: [
        { code: 0, codeName: "班级添加" },
        { code: 1, codeName: "报名添加" },
        { code: 2, codeName: "扫码添加" }
      ],
      tableItem: {
      }
    },
    // {
    //   title: "成绩",
    //   name: "score",
    //   tableItem: {
    //     width: 60,
    //     render: (text, record) => {
    //       let scoreVal = "";
    //       if(record.scoreState != 0 && record.scoreState !=3){
    //         scoreVal = record.score;
    //       }
    //       return scoreVal
    //     }
    //   },
    // },
    // {
    //   title: "通过状态",
    //   name: "scoreState",
    //   dict: [
    //     { code: 1, codeName: '通过' },
    //     { code: 2, codeName: '未通过' },
    //     { code: 3, codeName: '无成绩' },
    //   ],
    //   tableItem: {
    //     width: 90,
    //   },
    // }
  ]
};

const templateConfig = (data) => {
  const {_btnFun,_btnLookUserFun,personIds,scoreState,status} = data;
  return {
    mainProps: {},
    content: {
      name: "WizTableList",
      params: {
        columns: columns(data),
        searchBarProps: {
          cols: {
            xs: 24,
            md: 12,
            xl: 8
          },
          buttonSort: ['add','batchImport','exportStudents', 'sweepCodeRecord'],
          buttons: [
            {
              key: "add",
              name: "WizButton",
              custom: true,
              params: { icon: 'plus', children: '新增', type: 'primary',tooltip:status!= 1 ? "班级发布状态才可新增学员":null,
                key: "_btn",
              },
              customOnClick: {
                key: "modal",
                params: {
                  modalKey:'addModal',
                  modalParams: {
                    title: "新增学员",
                    diy: (e) => {
                      return (
                        <ClassStudentAdd
                          key={new Date()}
                          {...e}
                          id={data.classInfoId}
                          personIds={personIds}
                          ref={r => {
                            ref_ = r && r.getWrappedInstance();
                          }}
                        />
                      )
                    },

                    onOk: () => {
                      ref_._addClassStudentSubmit()
                    },
                    onCancel: () => {
                    },
                    width: 1000
                  }
                },
                formatParams: (rows, record, filter) => {
                  return { ...record };
                }
              },
              recordChangeParams: ({ record, rows }) => {
                return { disabled: !(status === 1) }
              }
            },
            {
              key: "batchImport",
              custom: true,
              params: { children: "导入学员", type: "info" ,tooltip:status!= 1 ? "班级发布状态才可导入学员":null},
              customOnClick: {
                key: "modal",
                params: {
                  modalParams: {
                    title: "导入学员",
                    diy: (e) => (
                      <ClassStudentFileImport
                        {...e} classInfoId={data.classInfoId} key={new Date()}
                        // ref={r => {
                        //   ref_ = r && r.getWrappedInstance();
                        // }}
                      />
                    ),
                    footer: null,
                    // onOk: () => {
                    //   ref_._ok(data);
                    // },
                    width: 1000
                  }
                }
              },
              recordChangeParams: ({ record, rows }) => {
                return { disabled: !(status === 1) }
              }
            },
            {
              key: "exportStudents",
              custom: true,
              params: {icon: 'export', children: '导出学员', type: 'export'},
              customOnClick: {
                key: "action",
                params: {
                  apiKey: "exportPerson",
                  apiParams: {}
                },
                formatParams: (rows, record, filters, callback) => {
                  return { ...filters, classInfoId: data.classInfoId }
                }
              }
            },
            {
              key: "sweepCodeRecord",
              custom: true,
              params: {children: '入店扫码记录'},
              customOnClick: {
                key: 'jumpPage',
                params: {
                  key: 'push',
                  pathname: '/face/classList/classStudentQrList',
                  record: data.classDetail
                }
              }
            }
          ]
        },
        modalFormProps: {
          key: "modal123",
          params: {
            modalParams: {
              title: "Modal",
              children: "Bla bla123 .."
            }
          }
        },
        dataTableProps: {
          rowKey: "id",
          selectType: "checkbox",
          isScroll: true,
          bordered: false,
          paging: false,
          loading: false,
        },
        rowOperateSort: ['askLeaveOrUnLeave'],
        rowOperateView: [
          // {
          //   key: "look",
          //   name: "WizButton",
          //   params: {  children: "查看已选任职",
          //     key: "_btn",
          //   },
          //   onClick: e => _btnLookUserFun && _btnLookUserFun(e),
          // },
          {
            key: "askLeaveOrUnLeave",
            custom: true,
            params: {children: "请假"},
            textFormat: {
              recordKey: 'leaveState',
              dirt: {0: '请假', 1: '取消请假'}
            },
            customOnClick: {
              key: "action",
              params: {
                apiKey: "leaveState",
                apiParams: {}
              },
              formatParams: (rows, record, filters, callback) => {
                let statusNameStr= record['leaveState'] ?  "取消请假吗" : "请假吗" ;
                const content = `您确定要`+statusNameStr;
                WizModal.confirm({
                  title: '注意', content,
                  onOk: () => {
                    callback && callback({
                      leaveState:  record['leaveState'] ? 0 : 1,
                      id: record['id'],
                      classInfoId : record['classInfoId']
                    })
                  },
                  onCancel() {
                  }
                });
                return null
              }
            },
            recordChangeParams: (record, rows) => {
              let result = { disabled: false };
              if (record.record && record.record.scoreState) {
                result.disabled = true
              }
              return result
            },


          },
        ],
        commonOperate: {
          add: true,
          delete: false,
          look: true
        }
      }
    }
  };
};

const apis = (data) => {
  const {classInfoId} = data;
  return {
    list: {
      path: `${componentName}/getListByPage`,
      payload: {
        key: `${componentName}@getListByPage`,
        apiParams: {pageNum: 1, pageSize: 10,classInfoId}
      }
    },
    add: {
      path: `${componentName}/add`,
      payload: {
        key: `${componentName}@add`,
        apiParams: {}
      }
    },
    delete: {
      path: `${componentName}/delete`,
      payload: {
        key: `${componentName}@delete`,
        apiParams: {}
      }
    },
    exportQuestionnaire: {
      path: `${componentName}/exportQuestionnaire`,
      payload: {
        key: `${componentName}@exportQuestionnaire`,
        apiParams: {}
      }
    },
    exportPerson: {
      path: `${componentName}/exportPerson`,
      payload: {
        key: `${componentName}@exportPerson`,
        apiParams: {classInfoId}
      }
    },
    leaveState: {
      path: `${componentName}/leaveState`,
      payload: {
        key: `${componentName}@leaveState`,
        apiParams: {}
      }
    }
  }
};


let reduxTemplateConfig = (args) => {
  const {classInfoId} = args;
  return {
    apis: apis({classInfoId}),
    componentName,
    initApiKeys: ['list'],
    keepInitApiParams:true,
    needLoading: true,
    ...args
  }
};

export {reduxTemplateConfig, templateConfig};
